import { render, staticRenderFns } from "./market-list.vue?vue&type=template&id=27aecb0e&scoped=true&"
import script from "./market-list.vue?vue&type=script&lang=js&"
export * from "./market-list.vue?vue&type=script&lang=js&"
import style0 from "../../component/public/css/table.scss?vue&type=style&index=0&id=27aecb0e&prod&lang=scss&scoped=true&"
import style1 from "./market-list.vue?vue&type=style&index=1&id=27aecb0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aecb0e",
  null
  
)

export default component.exports